import * as Sentry from '@sentry/react';
import {CSSProperties} from 'react';
import {Link, useNavigate} from 'react-router-dom';

import errorIllustationImage from 'Images/error-illustration.png';
import font from 'Style/font';
import color from '~/color';

const style: Record<string, CSSProperties> = {
  infos: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: color.whiteSmoke,
  },
  message: {
    fontFamily: font.family.sans,
    fontSize: font.size.display,
    color: color.emphasis,
    fontWeight: font.weight.semibold,
  },
  errorContainer: {
    display: 'flex',
  },
  number: {
    backgroundColor: color.emphasis,
    color: color.white,
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '8px',
    fontSize: font.size.headline,
  },
  image: {
    width: '300px',
    marginBottom: '32px',
  },
  spacer: {
    marginBottom: '4px',
  },
};

const FallbackComponent: Sentry.FallbackRender = ({resetError}) => {
  const navigate = useNavigate();

  const backToApp = () => {
    resetError();
    navigate('/');
  };

  return (
    <div style={style.infos}>
      <img src={errorIllustationImage} alt="home image" style={style.image} />
      <div style={style.message}>
        <div>
          Désolé, on dirait que vous avez rencontré une erreur. <br />
          Comment pouvons-nous vous aider à retrouver votre chemin ?<br />
          <br />
          <div style={style.errorContainer}>
            <span style={style.number}>1</span>
            <span>
              Retourner sur{' '}
              <Link to="/" onClick={backToApp}>
                {"l'application Buildrz"}
              </Link>
            </span>
          </div>
          <div style={style.spacer} />
          <div style={style.errorContainer}>
            <span style={style.number}>2</span>
            <a href="#">Contacter notre équipe</a>
          </div>
        </div>
      </div>
    </div>
  );
};

type TProps = {
  children: JSX.Element;
};

export default function ErrorBoundary({children}: TProps): JSX.Element {
  return (
    <Sentry.ErrorBoundary fallback={props => <FallbackComponent {...props} />}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
